import { PublicReportResponse } from './types';
import { PUBLIC_REPORT_API_BASE_URL } from '../../aws-exports';

export class PublicReportNotFoundError extends Error {
  constructor(listId: string) {
    super(`Report not found for list: ${listId}`);
    this.name = 'PublicReportNotFoundError';
  }
}

export async function fetchPublicReport(listId: string): Promise<PublicReportResponse> {
  const url = `${PUBLIC_REPORT_API_BASE_URL}public/qr/lists/${listId}/report`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.status === 404) {
    throw new PublicReportNotFoundError(listId);
  }

  if (!response.ok) {
    throw new Error(`Failed to fetch report: ${response.status}`);
  }

  return response.json();
}
